<template>
  <div id="personal">
    <div class="content-container">
      <!--<div class="personalHeader">
        <div class="leftInfo">
       &lt;!&ndash;   <span class="headerName">个人中心</span>&ndash;&gt;
        </div>
        <div class="rightInfo">
          <el-button  @click="preserveClick" type="danger" v-if="formLabelAlign.userRole ==='人工客服'">保存</el-button>
          <el-button  @click="preserveClick" type="primary" v-if="formLabelAlign.userRole !=='人工客服'">保存</el-button>
        </div>
      </div>-->
      <div style="display: flex">
        <el-menu
                :default-active="active"
                class="el-menu-vertical-demo"
                style="width: 160px;text-align: center;"
                @select="handleSelect"
        >
          <el-menu-item index="personal" :class="{activeClass:active==='personal'}">
            <span slot="title">个人中心</span>
          </el-menu-item>
          <el-menu-item index="password" :class="{activeClass:active==='password'}" v-if="userSource!==2">
            <span slot="title">修改密码</span>
          </el-menu-item>
        </el-menu>
        <div class="personalContent">
          <div class="rightInfo">
            <el-button  @click="preserveClick" type="danger" v-if="formLabelAlign.userRole ==='人工客服'">保存</el-button>
            <el-button  @click="preserveClick" type="primary" v-if="formLabelAlign.userRole !=='人工客服'">保存</el-button>
          </div>
          <div class="formInfo" v-if="active ==='personal'">

            <!-- <el-form :label-position="labelPosition" label-width="80px" :model="formLabelAlign" :rules="rules" >
              <el-form-item label="昵称" prop="petName">
                <el-input v-model="formLabelAlign.petName" style="min-width: 200px;max-width: 40%"></el-input>
              </el-form-item>
              <el-form-item label="姓名" prop="realName">
                <el-input v-model="formLabelAlign.realName" style="min-width: 200px;max-width: 40%"></el-input>
              </el-form-item>
              <el-form-item label="手机号" prop="phone">
                <el-input v-model="formLabelAlign.type" style="min-width: 200px;max-width: 50%"></el-input>
              </el-form-item>
            </el-form>-->
            <div style="display: flex">
              <div style="flex: 0.85">
                <div class="petName">
                  <div class="formTitle">
                    <span style="color: red">*</span>
                    <label>昵称</label>
                  </div>
                  <el-input
                          v-model="formLabelAlign.petName"
                          style="width: 80%"
                          placeholder="请输入昵称"
                  ></el-input>
                </div>
                <div class="realName">
                  <div class="formTitle">
                    <span style="color: red">*</span>
                    <label>姓名</label>
                  </div>
                  <el-input
                          v-model="formLabelAlign.realName"
                          style="width: 80%"
                          placeholder="请输入姓名"
                  ></el-input>
                </div>
              </div>

              <div class="headImage" style="flex: 0.25">
                <el-upload
                        class="upload-demo"
                        ref="upload"
                        :action="uploadUrl"
                        :show-file-list="false"
                        :on-success="handleAvatarSuccess"
                        :on-error="handleError"
                        :before-upload="beforeAvatarUpload"
                        :data="uploadAvatarParams"
                        :with-credentials="false"
                >
                  <div class="block">
                    <el-avatar :size="70" :src="fileList" fit="cover"></el-avatar>
                  </div>
                  <div
                          style="padding-top: 10px"
                          :class="{
                    ImClassT: formLabelAlign.userRole === '人工客服',
                    otherClassT: formLabelAlign.userRole !== '人工客服',
                  }"
                  >
                    修改头像
                  </div>
                </el-upload>
              </div>
            </div>
            <div class="userPhone">
              <div class="formTitle">
                <label>手机号码</label>
              </div>
              <el-input
                      v-model="formLabelAlign.phone"
                      style="width: 100%"
                      placeholder="请输入手机号"
              ></el-input>
            </div>
            <div class="accountNumber">
              <div class="formTitle">
                <label>账号</label>
              </div>
              <el-input
                      v-model="formLabelAlign.accountNumber"
                      style="width: 100%"
                      disabled
              ></el-input>
            </div>
            <div class="userRole">
              <div class="formTitle">
                <label>用户角色</label>
              </div>
              <el-input
                      v-model="formLabelAlign.userRole"
                      style="width: 100%"
                      disabled
              ></el-input>
            </div>
            <!-- <div>
              <el-button type="primary" v-if="currentUserWeWorkAuthInfo==null"  @click="openNewWindow">绑定企业微信</el-button>
              <el-button type="primary" v-else  @click="openNewWindow">已绑定企业微信{{currentUserWeWorkAuthInfo.user_info.name}},点击重新绑定</el-button>
            </div> -->
          </div>
          <div class="password" v-if="active === 'password'">
            <el-form :label-position="labelPosition" label-width="80px" :model="passWord">
              <el-form-item label="原始密码">
                <span slot="label"><span style="color: red">*</span>原始密码</span>
                <el-input v-model="passWord.oldPassword"  show-password  style="width: 80%;" placeholder="请输入原始密码" @blur="oldPasswordBlur"></el-input>
              </el-form-item>
              <el-form-item label="新密码">
                <span slot="label"><span style="color: red">*</span>新密码</span>
                <el-input v-model="passWord.newPassword"   show-password  style="width: 80%;" placeholder="请输入新密码" @blur="newPasswordBlur"></el-input>
              </el-form-item>
              <el-form-item label="确认密码">
                <span slot="label"><span style="color: red">*</span>确认密码</span>
                <el-input v-model="passWord.againPassword"  show-password  style="width: 80%;" placeholder="请确认密码" @blur="againPasswordBlur"></el-input>
              </el-form-item>
            </el-form>
            <div style="padding: 8px 5px">密码需要满足以下条件</div>
            <div style="padding: 0px 5px;color: red">
              * 至少 6 个字符长度
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
name: "personal",
  data(){
  return{
    labelPosition: 'top',
    formLabelAlign:{
      petName:'小果',
      realName:'',
      phone:null,
      accountNumber:'',
      userRole:''
    },
    fileList:'https://cube.elemecdn.com/3/7c/3ea6beec64369c2642b92c6726f1epng.png',
    uploadUrl: "/open-api/oss/public",
    uploadAvatarParams: {
      token:'8c98087dfd2d48f856d8c95c09115def'
    },
    uploadImg:'',
    userInfo:{},
    uid:localStorage.getItem('_uid'),
    active:'personal',
    passWord:{
      oldPassword:'',
      newPassword:'',
      againPassword:''
    },
    OriginalPassword:'',//原始密码
    userSource:0,
    currentUserWeWorkAuthInfo:null
  }
  },
  mounted() {
  this.getUserInfo()
    console.log(localStorage.getItem('_uid'))
   /* this.uploadAvatarParams.token=localStorage.getItem('token')*/
  },
  methods:{
    // 上传头像
    handleAvatarSuccess(res,file) {
      console.log(res)
      if(res!=='')
      {
        this.uploadImg=res
      }

      // this.form.avatar=res.data.data
      this.fileList = URL.createObjectURL(file.raw)
      console.log(this.fileList)
      console.log('上传图片成功')
    },
    handleError() {
      console.log('图片上传失败')
    },
    beforeAvatarUpload(file) {
      const isSupportedFormat = file.type === 'image/jpeg' || file.type === 'image/png' || file.type === 'image/jpeg'
      const isLte2M = file.size / 1024 / 1024 <= 2

      if (!isSupportedFormat) {
        this.$message.error('上传头像图片只能是 JPG 或 PNG 格式 或 JPEG 格式!')
      }
      if (!isLte2M) {
        this.$message.error('上传头像图片大小不能超过 2MB!')
      }
      return isSupportedFormat && isLte2M
    },
    //获取用户信息
    getUserInfo(){
      let uid=localStorage.getItem('_uid')
      console.log(localStorage.getItem('roleId'))
      this.$http.get('/portal-api/account/appoint/'+uid).then(res=>{
        console.log(res)
        if(res.data.code==='0')
        {
          console.log(res.data.data)
          this.userInfo=res.data.data;
          this.currentUserWeWorkAuthInfo = this.userInfo.weWorkQrCodeLoginInfo;
          //初始化姓名
          if(this.userInfo.realName!==null)
          {
            this.formLabelAlign.realName=this.userInfo.realName
          }
          //初始化来源
          if(this.userInfo.source!==null)
          {
            this.userSource=this.userInfo.source
          }
          //初始化账户
          this.formLabelAlign.accountNumber=this.userInfo.username
          //初始化昵称
          if(this.userInfo.nickName!==null)
          {
            this.formLabelAlign.petName=this.userInfo.nickName
          }
          //初始化电话
          if(this.userInfo.tel!==null)
          {
            this.formLabelAlign.phone=this.userInfo.tel
          }
          //初始化角色
          if(this.userInfo.roles[0]!==null)
          {
            this.formLabelAlign.userRole=this.userInfo.roles[0]
          }

          else
          {
            let roles=localStorage.getItem('roleId')
            let rolesName=''
            if(roles ==='0')
            {
              rolesName='系统测试'
            }
            if(roles ==='1')
            {
              rolesName='超级管理员'
            }
            if(roles ==='2')
            {
              rolesName='机器人管理员'
            }
            if(roles ==='3')
            {
              rolesName='机器人配置员'
            }
            if(roles ==='4')
            {
              rolesName='人工客服'
            }
            if(roles ==='5')
            {
              rolesName='工单管理员'
            }
            if(roles ==='6')
            {
              rolesName='工单成员'
            }
            this.formLabelAlign.userRole=rolesName
          }
          //初始化头像
          if(this.userInfo.profilePhoto!==null || this.userInfo.profilePhoto!=='')
          {
            this.fileList=this.userInfo.profilePhoto
            this.uploadImg=this.userInfo.profilePhoto
          }
        }
      })
    },
    //保存用户信息
    preserveClick(){
      if(this.active === 'personal'){
        this.$refs.upload.submit();
        if(this.formLabelAlign.petName==='')
        {
          this.$message.error('请完善昵称')
          return
        }
        if(this.formLabelAlign.realName==='')
        {
          this.$message.error('请完善姓名')
          return
        }

        if(this.formLabelAlign.phone!==null) {
          let test = !/^1[34578]\d{9}$/.test(this.formLabelAlign.phone)
          if (test) {
            this.$message({
              message: "请填写正确的手机号",
              type: "warning",
              duration: 3000
            });
            return
          }
        }
        console.log(this.userInfo.roles)
        let userInfo={
          nickName:this.formLabelAlign.petName,
          realName:this.formLabelAlign.realName,
          tel:this.formLabelAlign.phone,
          profilePhoto:this.uploadImg
        }
        console.log(userInfo)
        let uid=localStorage.getItem('_uid')
        this.$http.put('/portal-api/account/appoint/'+uid,userInfo).then(res=>{
          console.log(res)
          if (res.data.code==='0')
          {
            this.$message.success('保存成功')
          }
        })
      }

      else if(this.active === 'password')
      {
        if(this.passWord.oldPassword==='')
        {
          this.$message({
            type:'error',
            message:'原始密码不能为空',
            duration:2000
          })
          return;
        }
        if(this.passWord.oldPassword!=='')
        {
          let userInfo={username:this.userInfo.username,password:this.passWord.oldPassword}
          this.$http.post('/sso/login-r',userInfo).then(res=>{
            console.log('密码',res)
            if(res.data === 0)
            {
              this.$message({
                message:'密码错误',
                type:'error',
                duration:2000
              })
              return
            }
          })
        }
        if(this.passWord.newPassword==='')
        {
          this.$message({
            type:'error',
            message:'新密码不能为空',
            duration:2000
          })
          return;
        }
        if(this.passWord.newPassword!=='')
        {
          if(this.passWord.newPassword.length < 6)
          {
            this.$message({
              type:'error',
              message:'密码长度最少为6位',
              duration:2000
            })
            return;
          }
          if(this.passWord.newPassword===this.passWord.oldPassword)
          {
            this.$message({
              type:'error',
              message:'新密码不能与原始密码一样',
              duration:2000
            })
            return;
          }
        }
        if(this.passWord.againPassword==='')
        {
          this.$message({
            type:'error',
            message:'请输入确认密码',
            duration:2000
          })
          return;
        }
        if(this.passWord.againPassword!=='')
        {
          if(this.passWord.againPassword!==this.passWord.newPassword)
          {
            this.$message({
              type:'error',
              message:'密码不一致',
              duration:2000
            })
            return;
          }
        }
        let url='/sso/change-pass'
        this.$http.post(url,{username:this.formLabelAlign.accountNumber,oldPassword:this.passWord.oldPassword,newPassword:this.passWord.newPassword}).then(res=>{
          console.log(res)
          if(res.data=== 1)
          {
            this.$message({
              message:'密码修改成功',
              type:'success',
              duration:2000
            })
            this.passWord.oldPassword=''
            this.passWord.newPassword=''
            this.passWord.againPassword=''
            setTimeout(()=>{
              this.$http.delete("/api/sso/auth/sign-out").then(res => {
                console.log("=======signout result:",res);
                if (res.status === 200) {
                  this.$router.push({
                    name: "CheckAuth"
                  });
                } else {
                  this.$message.error(res.message)
                }
              });
            },2000)
          }

        })

      }
    },
    //验证手机号码是否正确
    codePhone(){
      if(this.formLabelAlign.phone!=='')
      {
        if (!/^1[34578]\d{9}$/.test(this.formLabelAlign.phone)) {
          this.$message({
            message: "请填写正确的手机号",
            type: "warning",
            duration: 3000
          });
        }
      }

    },
    handleSelect(key,path){
      console.log(key,path)
      this.active=key
    },
    oldPasswordBlur(){
      if(this.passWord.oldPassword!=='')
      {
        this.$http.post('/sso/login-r',{username:this.userInfo.username,password:this.passWord.oldPassword}).then(res=>{
          console.log('密码',res)
          if(res.data === 0)
          {
            this.$message({
              message:'密码错误',
              type:'error',
              duration:2000
            })
            return
          }
        })
      }
    },
    //新密码输入失焦时校验
    newPasswordBlur(){
      /* if (/[^\w\.\/]/ig.test(this.passWord.newPassword))
       {
         this.$message({
           type:'error',
           message:'密码中不要含有中文',
           duration:2000
         })
         return;
       }*/
      if(this.passWord.newPassword!=='')
      {
        if(this.passWord.newPassword.length < 6)
        {
          this.$message({
            type:'error',
            message:'密码长度最少为6位',
            duration:2000
          })
          return;
        }
        if(this.passWord.newPassword===this.passWord.oldPassword)
        {
          this.$message({
            type:'error',
            message:'新密码不能与原始密码一样',
            duration:2000
          })
          return;
        }
      }
    },
    //重新输入密码时失去焦点校验
    againPasswordBlur(){
      /*  if (/[^\w\.\/]/ig.test(this.passWord.againPassword))
        {
          this.$message({
            type:'error',
            message:'密码中不要含有中文',
            duration:2000
          })
          return;
        }*/
      if(this.passWord.againPassword!=='')
      {
        if(this.passWord.againPassword!==this.passWord.newPassword)
        {
          this.$message({
            type:'error',
            message:'密码不一致',
            duration:2000
          })
          return;
        }
      }

    },
    openNewWindow(){
      ///#/qrCodeCallBack
      let that = this;
      this.$http.get('/scrm-api/we-work/sso/3rd-qr-connect?redirect_uri='+encodeURIComponent(process.env.VUE_APP_SCRM_HOST+'/qrcode-callback.html'))
      .then(res=>{
        console.debug('qr code url',res);
       let w =  window.open(res.data,'newwindow', 'height=500, width=500, top=200, left=500, toolbar=no, menubar=no, scrollbars=no, resizable=no,location=n o, status=no')
        var loop = setInterval(function() {

          if(w  != null && w.closed) {
            that.getUserInfo()
            clearInterval(loop);

            //do something 在这里执行回调
          }

        }, 800);
      });
      
    }
  }
}
</script>

<style lang="less">
@import "../../assets/less/personal/personal";


.ImClassT{
  color: red;
}


.otherClassT{
  color: #409eff;
}
.activeClass{
  border-right: 2px solid #409eff;
}
</style>
